export default "__VITE_ASSET__DhCfZWct__"